const resultFunction = (...state) => [...state].every(({ loaded }) => loaded === true)

const loadedSelectorDefinition = {
  id: 'loaded',
  resultFunction,
  dependencies: [
    //
    { selector: 'assets' },
    { selector: 'countries' },
    { selector: 'config' },
  ],
}

export default loadedSelectorDefinition
